






































































import Vue, { PropType } from 'vue';
import WidgetWrapper from '@/components/widgets/WidgetWrapper.vue';
import FieldDatePicker from '@/components/form/FieldDatePicker.vue';
import { ScheduleTime } from '@/types';
import { ScheduleData } from '@/types/campaign/settings';

export default Vue.extend({
  name: 'TheSchedule',
  components: { WidgetWrapper, FieldDatePicker },
  props: {
    data: {
      type: Object as PropType<ScheduleData>,
      required: true,
    },
  },

  mounted() {
    this.datePeriod = [...this.data.date];

    if (this.data.times?.length) {
      this.weekTimes = [...this.data.times];
    } else {
      this.sedDefaultHoursState();
    }
  },

  watch: {
    data() {
      this.datePeriod = this.data.date;

      if (this.data.times?.length) {
        this.weekTimes = this.data.times;
      } else {
        this.sedDefaultHoursState();
      }
    },
  },

  methods: {
    changeDate() {
      this.$emit('changeDate', this.datePeriod);
    },
    setHourOfDay(dayIndex, hour) {
      return !!(this.weekTimes[dayIndex]?.times.indexOf(hour) + 1);
    },
    changeHour(dayIndex, hourIndex) {
      this.isPressed = true;
      const index = this.weekTimes[dayIndex].times.indexOf(hourIndex + 1);
      if (index + 1) {
        this.weekTimes[dayIndex].times.splice(index, 1);
      } else {
        this.weekTimes[dayIndex].times.splice(hourIndex, 0, hourIndex + 1);
      }

      this.$emit('changeTime', this.weekTimes);
    },
    showHour(event, dayIndex, hourIndex) {
      if (this.isPressed) {
        this.changeHour(dayIndex, hourIndex);
      }
      event.target.textContent = event.target.dataset.hourValue;
    },
    hideHour(event) {
      event.target.textContent = '';
    },
    sedDefaultHoursState() {
      let startHour = 1;
      this.weekScale.forEach((item, index) => {
        if (this.weekTimes[index].times.length) return;
        while (startHour <= this.dayHours) {
          this.weekTimes[index].times.push(startHour++);
        }
        startHour = 1;
      });
      this.$emit('changeTime', this.weekTimes);
    },
    changeChecked(checked) {
      this.$emit('changeCampaign', 'is_schedule', checked);
    },
  },

  data() {
    return {
      dayHours: 24,
      isPressed: false,
      datePeriod: [] as Array<string>,
      timeScale: ['0:00', '12:00', '24:00'],
      weekScale: [
        this.$t('body.calendar.mo'),
        this.$t('body.calendar.tu'),
        this.$t('body.calendar.we'),
        this.$t('body.calendar.th'),
        this.$t('body.calendar.fr'),
        this.$t('body.calendar.sa'),
        this.$t('body.calendar.su'),
      ],
      weekTimes: [
        { day_of_week: 'monday', times: [] },
        { day_of_week: 'tuesday', times: [] },
        { day_of_week: 'wednesday', times: [] },
        { day_of_week: 'thursday', times: [] },
        { day_of_week: 'friday', times: [] },
        { day_of_week: 'saturday', times: [] },
        { day_of_week: 'sunday', times: [] },
      ] as Array<ScheduleTime>,
    };
  },
});
